<template>
  <div>
    <div v-show="isMain">
    <div class="white-background list-top-margin">
      <!-- 面包屑导航 -->
      <div class="page-top">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>系统配置</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span style="color:#000;font-weight:bold;">用户</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <!-- 搜索筛选 -->
      <el-form :model="form" class="user-search" label-width="110px" size="small">
        <el-row>
            <el-col :span="7">
                <el-form-item label="姓名">
                <el-input size="small" v-model="form.condition.name" placeholder="请输入姓名" clearable></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="7">
                <el-form-item label="状态">
                    <el-select
                        v-model="userStatus"
                        clearable
                        filterable
                        placeholder="请选择"
                        style="width:100%;"
                        @change="statusChange"
                    >
                        <el-option
                        v-for="item in userStatusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="7">
                <el-form-item label="手机号">
                <el-input size="small" v-model="form.condition.account" placeholder="请输入手机号" clearable></el-input>
                </el-form-item>
            </el-col>

          <el-col :span="3" class="text-align-right">
            <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
          </el-col>
        </el-row>
        <el-row>
            <el-col :span="7">
                <el-form-item label="虚拟用户">
                    <el-select
                        v-model="virtualUser"
                        clearable
                        filterable
                        placeholder="请选择"
                        style="width:100%;"
                        @change="virtualUserChange"
                    >
                        <el-option
                        v-for="item in virtualUserList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-col>

            <el-col :span="7">
                <el-form-item label="角色">
                    <el-select
                        v-model="role"
                        clearable
                        filterable
                        placeholder="请选择"
                        style="width:100%;"
                        @change="roleChange"
                    >
                        <el-option
                        v-for="item in roleList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <!-- <el-col :span="7">
                <el-form-item label="部门">
                    <el-select
                        v-model="form.condition.departmentName"
                        clearable
                        multiple
                        filterable
                        placeholder="请选择"
                        style="width:100%;"
                    >
                        <el-option
                        v-for="item in deptList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-col> -->


        </el-row>

      </el-form>
    </div>

    <div class="white-background">
        <el-row class="tbl-btn">
          <el-col :span="12" class="tbl-btn-left">
            <el-button size="small" type="primary" icon="el-icon-plus" @click="createProduct">新增用户</el-button>
            <!-- <el-dropdown class="left-default-margin right-default-margin" @command="handleCommand" trigger="click">
              <el-button type="primary" size="small" plain icon="el-icon-s-operation">批量操作</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="delete"><i class="el-icon-delete"></i>批量删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
            <el-button size="small" type="primary" plain icon="el-icon-download" @click="templateDownload">模板下载</el-button>
            <el-button size="small" type="success" plain icon="el-icon-upload2" @click="importData">导入</el-button>
            <el-button size="small" type="success" plain icon="el-icon-s-promotion" @click="exportExcelNew">导出</el-button>

            <el-upload  ref="workReportImp" name="workReportImp" :action="action()" :on-change="
                (file, fileList) => {
                handleChange(file, fileList);
                }
            "
              :auto-upload="false" :show-file-list="false" accept=".xlsx" v-show="false">

            </el-upload>
            <!-- <el-button size="small" type="primary" plain icon="el-icon-download">导入</el-button>
            <el-button size="small" type="primary" plain icon="el-icon-upload2">导出</el-button>
            <el-button type="text" icon="el-icon-s-data" @click="viewImportLog">查看导入日志</el-button>
            <el-button type="text" icon="el-icon-edit-outline">编辑打印模板</el-button> -->
          </el-col>
          <!-- <el-col :span="12" class="tbl-btn-right">
            <el-button type="default" size="small" icon="el-icon-s-operation">列配置</el-button>
          </el-col> -->
        </el-row>
        <!--列表-->
        <el-table
        ref="tableData"
          size="small"
          :data="listData"
          highlight-current-row
          v-loading="loading"
          stripe
          border
          :header-cell-style="_headerStyle"
          element-loading-text="加载中"
          style="width: 100%;"
          row-key="_id"
          @selection-change="handleTblSelectionChange"
        >
          <el-table-column align="left" type="selection" width="60" :reserve-selection="true"></el-table-column>
          <el-table-column align="left" type="index" width="50" label="序号"></el-table-column>
          <!-- <el-table-column sortable prop="account" label="账号"  width="120"></el-table-column> -->
          <el-table-column prop="name" label="姓名" ></el-table-column>

          <el-table-column prop="phoneNum" label="手机号" width="100"></el-table-column>
          <el-table-column prop="role" label="角色">

          </el-table-column>
          <el-table-column prop="departmentName" label="部门名称"></el-table-column>
          <el-table-column prop="virtualUser" label="虚拟用户">
            <template slot-scope="scope">
              <span>{{scope.row.virtualUser?'是':'否'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="userStatus" label="状态">
            <template slot-scope="scope">
              <span>{{scope.row.userStatus == 'Y'?'启用中':'停用中'}}</span>
            </template>
          </el-table-column>
          <el-table-column v-for="item in setList" :key="item._id" :prop="item.fieldName" :label="item.fieldName"></el-table-column>
          <!-- <el-table-column prop="deptNo" label="绩效系数"></el-table-column>
          <el-table-column prop="deptNo" label="职位类型"></el-table-column>
          <el-table-column prop="deptNo" label="基本工资"></el-table-column>
          <el-table-column prop="deptNo" label="五险一金扣除金额" width="150"></el-table-column>
          <el-table-column prop="deptNo" label="请假小时"></el-table-column>
          <el-table-column prop="deptNo" label="请假1小时扣除金额" width="150"></el-table-column>
          <el-table-column prop="deptNo" label="入职时间"></el-table-column>
          <el-table-column prop="deptNo" label="发放工资次数" width="100"></el-table-column> -->

          <el-table-column prop="creater" label="创建人" ></el-table-column>

          <el-table-column prop="createTime" label="创建时间" sortable></el-table-column>
          <el-table-column prop="updater" label="更新人" ></el-table-column>
          <el-table-column prop="updateTime" label="更新时间" sortable></el-table-column>
          <el-table-column align="left" label="操作" min-width="100" fixed="right">
            <template slot-scope="scope">
                <el-tooltip content="重置密码">

                    <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-refresh"
                    circle
                    @click="handleResetPwd(scope.$index, scope.row)"
                    ></el-button>
                </el-tooltip>
                <el-tooltip content="编辑">

                    <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit"
                    circle
                    @click="handleEdit(scope.$index, scope.row)"
                    ></el-button>
                </el-tooltip>

                <el-tooltip content="停用" v-if="scope.row.userStatus == 'Y'" style="margin-left: 10px;">
                   <el-popconfirm title="确认停用？" @confirm="deactiveUser(scope.$index, scope.row)">
                    <el-button
                        size="mini"
                        type="danger"
                        icon="el-icon-delete"
                        circle
                        slot="reference"
                    ></el-button>
                  </el-popconfirm>
                </el-tooltip>
                <el-tooltip content="启用" v-if="scope.row.userStatus == 'N'" style="margin-left: 10px;">
                   <el-popconfirm title="确认启用？" @confirm="activeUser(scope.$index, scope.row)">
                    <el-button
                        size="mini"
                        type="success"
                        icon="el-icon-check"
                        circle
                        slot="reference"
                    ></el-button>
                  </el-popconfirm>
                </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather" class="tbl-pagination"></Pagination>
      </div>
      </div>
      <ImportLog v-show="!isMain" :menuName="menuName" @goBack="goBack"></ImportLog>
      <createUser :diaVisible="createProductPanVisible" :rowData="row" @save="productSave" @close="closeDialog" :deptList="deptList" :setList="setList"></createUser>
      <resetPwdPan :diaVisible="resetPwdVisible" :rowData="row" @save="resetPwdSave" @close="closeDialog"></resetPwdPan>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import ImportLog from "@/components/importLog";
import createUser from '@/views/systemSetting/userSys/createUser';
import resetPwdPan from '@/views/systemSetting/userSys/resetPwd';
import {queryUserList,queryDeptList,addUptUser,resetPwd,activeUser,deactiveUser,queryAllCustomSet,userBatchImp,exportExcel} from '@/api/business';
import {exportDataToExcel,transfer} from '@/utils/util';

export default {
  name: "userSys",
  components:{
      Pagination,
      createUser,
      ImportLog,
      resetPwdPan
  },
  data() {
    return {
      form: {
        "condition": {
          // "account": "",
          "departmentName": null,
          "factoryId": "",
          // "name": "",
          // "role": "",
          // "userStatus": "Y",
          // "virtualUser": false
        },
        "currentPage": 1,
        "pageSize": 10
      },
      row:{},
      userStatusList: [
        {
          label: "全部",
          value: "0"
        },
        {
          label: "启用中",
          value: "Y"
        },
        {
          label: "停用中",
          value: "N"
        }
      ],
      isFold: true,
      listData: [],
      loading: false,
      isBatchPrint: false,
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      createProductPanVisible:false,
      isMain:true,
      menuName:{
        first:'基础数据',
        second:'产品定义',
        three:'导入日志',
      },

      deptParam:{
        "condition": {
          "departmentCode": "",
          "departmentName": "",
          "factoryId":""
        },
        "currentPage": 1,
        "pageSize": 100
      },
       roleList:[
                {
                    label:"全部",
                    value:"全部"
                },
                {
                    label:"轻量管理员",
                    value:"轻量管理员"
                },
                {
                    label:"轻量生产人员",
                    value:"轻量生产人员"
                },
            ],
      deptList:[],
      virtualUserList:[
        {
            label: "全部",
            value: "0"
        },
        {
            label: "是",
            value: "1"
        },
        {
            label: "否",
            value: "2"
        },
      ],
      virtualUser:'0',
      userStatus:'0',
      role:'全部',
      user:JSON.parse(window.localStorage.getItem('userdata')),
      resetPwdVisible:false,
      setList:[],
      tblSelectionList:[]
    };
  },
  created() {
    this.form['condition']['factoryId'] = this.user['factoryId'];
    this.deptParam['condition']['factoryId'] = this.user['factoryId'];



    this.init();

  },
  methods: {
    //导出数据前对数据处理，变为想要的格式。
    filterTableData(data) {
      data.forEach((item) => {
       item.virtualUser = item.virtualUser?'是':'否';
       item.userStatus = item.userStatus == 'Y'?'启用中':'停用中';
      });
      return data;
    },
    exportExcelNew(){
      if(this.tblSelectionList == null || this.tblSelectionList.length == 0){
        this.exportData();

        return;
      }
      const header = [
        '姓名',
        '手机号',
        '角色',
        '部门名称',

        '虚拟用户',
        '状态',
        '创建人',
        '创建时间',
        '更新人',
        '更新时间',

      ];

      const filterVal = [
        'name',
        'phoneNum',
        'role',
        'departmentName',
        'virtualUser',
        'userStatus',
        'creater',
        'createTime',
        'updater',
        'updateTime',
      ];
      for(let k = 0;k<this.setList.length;k++){
        header.push(this.setList[k]['fieldName']);
        filterVal.push(this.setList[k]['fieldName']);
      }
      let filterData =this.filterTableData( JSON.parse(JSON.stringify(this.tblSelectionList)));
      let data = filterData.map(v => filterVal.map(j => v[j]));
      exportDataToExcel(data,header,"用户信息清册"+ Date.now());
    },
    exportData(){
      let params = {
        tableName:'用户',
        collection:'user',
        condition:this.form['condition']
      };
      var x = new XMLHttpRequest();
      var self = this;
      let url = this.$devEnv.API_ROOT + '/api/exportExcel';
      x.open("POST", url, true);
      x.responseType = 'blob';
      x.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      x.onload=function(e) {
          if (x.readyState === x.DONE) {
              if (x.status === 200) {
                  //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
                  var url = window.URL.createObjectURL(x.response)
                  var a = document.createElement('a');
                  a.href = url
                  a.download = "用户清册.xlsx";
                  a.click()
              }else {
                  self.$message({
                      type: 'error',
                      message: '下载失败',
                  });
              }
          }else {
              self.$message({
                  type: 'error',
                  message: '下载失败',
              });
          }
      }
      x.send(JSON.stringify(params));
    },
    handleChange(file, fileList){
        let data = new FormData();

        data.append("file", file.raw);
        data.append("factoryId ", this.user.factoryId);
        data.append("creater",this.user.name + "(" + this.user.account + ")");
        userBatchImp(data).then(res=>{
          this.search();

        });

    },
    action(){
      return this.$devEnv.API_ROOT + `/user/importData`;
    },
    templateDownload(){
      var x = new XMLHttpRequest();
      var self = this;
      let url = this.$devEnv.API_ROOT + '/user/downloadTemplate';
      x.open("GET", url, true);
      x.responseType = 'blob';
      x.onload=function(e) {
          if (x.readyState === x.DONE) {
              if (x.status === 200) {
                  //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
                  var url = window.URL.createObjectURL(x.response)
                  var a = document.createElement('a');
                  a.href = url
                  a.download = "用户导入模板.xlsx";
                  a.click()
              }else {
                  self.$message({
                      type: 'error',
                      message: '下载失败',
                  });
              }
          }else {
              self.$message({
                  type: 'error',
                  message: '下载失败',
              });
          }
      }
      x.send();
    },
    importData(){
      this.$refs["workReportImp"].$refs['upload-inner'].handleClick();
    },
    init(){
      queryDeptList(this.deptParam).then(res2=>{
          if(res2['code']==200){
            for(let i = 0;i<res2['data']['list'].length;i++){
              let obj = {
                label:res2['data']['list'][i]['departmentName'],
                value:res2['data']['list'][i]['departmentName'],
                _id:res2['data']['list'][i]['_id'],
              }
              this.deptList.push(obj);
            }
          }
      });
      queryAllCustomSet(this.form['condition']['factoryId'],'user').then(res=>{
        this.setList = [];
        if(res['code'] == 200){
          this.setList = res['data'];
        }
      })
      this.getList();
    },
    getList(){
      this.loading = true
      queryUserList(this.form).then(res1=>{
        if(res1['code'] == 200){
          this.listData = res1['data']['list'];
          this.pageparm.total = res1["data"]['total'];
        }
        this.loading = false
      });
    },
    virtualUserChange(val){
      if(val == 0){
        delete this.form['condition']['virtualUser'];
      }else{

        this.form['condition']['virtualUser'] = (val == '1')?true:false;
      }
    },
    roleChange(val){
      if(val == "全部"){
        delete this.form['condition']['role'];
      }else{
        this.form['condition']['role'] = val;
      }
    },
    statusChange(val){
      if(val == 0){
        delete this.form['condition']['userStatus'];
      }else{

        this.form['condition']['userStatus'] = val;
      }
    },
    fold() {
      this.isFold = !this.isFold;
    },
    search() {
        this.form['currentPage'] = 1;
        this.form['pageSize'] = 10;
        this.getList();
    },
    /**
     * 监听表格选中项变化事件
     */
    handleTblSelectionChange(val) {
      this.tblSelectionList = val;
      this.isBatchPrint = true;
    },
     // 分页插件事件
    callFather(param) {
      this.form['currentPage'] = param['currentPage'];
      this.form['pageSize'] = param['pageSize'];
      this.getList();
    },
    createProduct(){
        this.row = {};
        this.createProductPanVisible = true;
    },
    productSave(val){
        if(val){
          val['factoryId'] = this.user['factoryId'];
          addUptUser(val).then(res=>{
            if(res['code']==200){
              this.$message({
                type: 'success',
                message: '操作成功！'
              });
            }else{
              this.$message.error(res['msg'] || '操作失败！');
            }
            this.search();
            this.createProductPanVisible =false;
          })
        }

    },
     viewImportLog(){
      this.isMain = !this.isMain;
    },
    goBack(){
      this.isMain = !this.isMain;
    },
    handleEdit(index,row){
      this.row = {};
      this.$nextTick(()=>{
        this.row = row;
        this.createProductPanVisible = true;
      })

    },
    resetPwdSave(val){
      let param={
        _id:val['_id'],
        password:val['passwordNew']
      };
      resetPwd(param).then(res=>{
        if(res['code']==200){
          this.$message({
            type: 'success',
            message: '操作成功！'
          });
        }else{
          this.$message.error(res['msg'] || '操作失败！');
        }
        this.search();
      })

      this.resetPwdVisible = false;
    },
    closeDialog(){
      this.resetPwdVisible = false;
      this.createProductPanVisible = false;
    },
    handleResetPwd(index,row){
      this.row = {};
      this.$nextTick(()=>{

        this.row = row;
        this.resetPwdVisible = true;
      })

    },
    deactiveUser(index,row){
      deactiveUser(row['_id']).then(res=>{
        if(res['code']==200){
          this.$message({
            type: 'success',
            message: '操作成功！'
          });
        }else{
          this.$message.error(res['msg'] || '操作失败！');
        }
        this.search();
      })
    },
    activeUser(index,row){
      activeUser(row['_id']).then(res=>{
          if(res['code']==200){
            this.$message({
              type: 'success',
              message: '操作成功！'
            });
          }else{
            this.$message.error(res['msg'] || '操作失败！');
          }
          this.search();
      })
    },

  }
};
</script>
<style scoped>
.page-top {
  height: 30px;
  line-height: 30px;
}
.el-breadcrumb {
  line-height: 15px;
}
.page-row {
  /* background-color: #efefef; */
}
.page-row .el-tabs__nav-wrap::after {
  height: 0px;
}
.page-row .el-tabs__header {
  margin: 0px;
}

.user-search {
  margin-top: 20px;
}

.el-divider__text {
  padding: 0px 0px;
  font-size: 20px;
  cursor: pointer;
}
.tbl-pagination {
  text-align: right;
}
.tbl-btn {
  width: 100%;
  height: 40px;
  line-height: 40px;
}
.tbl-btn .tbl-btn-right {
  text-align: right;
}
.el-divider--horizontal {
  margin: 10px 0px;
}
.el-form-item {
  margin-bottom: 20px;
}
.search-row .half-width {
  width: calc(100% - 132px);
  margin-left: 8px;
}
.search-row .input-number {
  width: calc(50% - 5px);
}
</style>



// WEBPACK FOOTER //
// src/views/systemSetting/userSys/userSys.vue